export default __webpack_public_path__ + "static/media/ChristineJones-6.21737aa0.jpg";